import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import React, { useState } from 'react';

const ImagePreview: React.FC<{
  src: string;
  alt?: string;
  height?: number;
  width?: number;
}> = ({ src, alt, height, width }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      {/* Thumbnail / small image */}
      <img
        src={src}
        alt={alt}
        style={{
          width: width ?? 100,
          height: height ?? 100,
          cursor: 'pointer',
          borderRadius: 8,
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
        }}
        onClick={handleOpen}
      />

      {/* Fullscreen preview */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullScreen
        PaperProps={{
          style: { backgroundColor: 'rgba(0,0,0,0.9)' },
        }}
      >
        <IconButton
          aria-label='close'
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            color: 'white',
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            p: 0,
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImagePreview;
